var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c(
      "div",
      {
        staticClass:
          "w-full bg-gray-bg z-50 sticky pin-t md:relative md:w-1/4 pt-2 pb-5",
      },
      [
        _c("input", { attrs: { id: "dropdown", type: "checkbox" } }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass:
              "mobile__dropdown md:hidden block bg-black text-white uppercase text-lg px-3 py-3 flex",
            attrs: { for: "dropdown" },
          },
          [
            _c("span", { staticClass: "flex-1 block" }, [
              _vm._v("Current Step: " + _vm._s(_vm.pageTitle)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "block" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "17",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 16.667L0 0h20z",
                      fill: "#FFF",
                      "fill-rule": "evenodd",
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "list-reset nav__sidebar border-b-8 md:border-b-0 md:border-t-8 border-black overflow-hidden md:overflow-visible md:h-auto md:opacity-100",
          },
          [
            _vm.user.isAdmin
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "font-sans-bold text-red",
                        attrs: { to: `/resources/${_vm.resourceId}/admin` },
                      },
                      [_vm._v("\n          Admin Settings\n        ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.resourceRoutes, function (resourceRoute) {
              return _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      class: { errors: !resourceRoute.status },
                      attrs: { to: resourceRoute.to },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(resourceRoute.text) +
                          "\n          "
                      ),
                      resourceRoute.status
                        ? _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "active-white",
                                  attrs: {
                                    width: "28",
                                    height: "29",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "a",
                                        d: "M0 .557h27.444V28H0z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            transform: "translate(0 .318)",
                                          },
                                        },
                                        [
                                          _c(
                                            "mask",
                                            {
                                              attrs: { id: "b", fill: "#fff" },
                                            },
                                            [
                                              _c("use", {
                                                attrs: { "xlink:href": "#a" },
                                              }),
                                            ]
                                          ),
                                          _c("path", {
                                            attrs: {
                                              d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                              fill: "#000",
                                              mask: "url(#b)",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c("path", {
                                        attrs: {
                                          d: "M12.35 21.458c-.327 0-.644-.117-.895-.332l-4.803-4.127a1.372 1.372 0 0 1 1.789-2.082l3.627 3.117 6-9.001a1.372 1.372 0 1 1 2.284 1.522l-6.861 10.29a1.366 1.366 0 0 1-1.141.613",
                                          fill: "#000",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "tab-status-incomplete",
                                  attrs: {
                                    width: "28",
                                    height: "29",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "a",
                                        d: "M0 .557h27.444V28H0z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        transform: "translate(0 .318)",
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        { attrs: { id: "b", fill: "#fff" } },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#a" },
                                          }),
                                        ]
                                      ),
                                      _c("path", {
                                        attrs: {
                                          d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                          fill: "#9B9B9B",
                                          mask: "url(#b)",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ]
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.user.isAdmin
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        class: { errors: !_vm.resourceTagStatus },
                        attrs: { to: `/resources/${this.resourceId}/tags` },
                      },
                      [
                        _vm._v("\n          Tags\n          "),
                        _vm.resourceTagStatus
                          ? _c(
                              "span",
                              { staticClass: "flex flex-1 justify-end" },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "active-white",
                                    attrs: {
                                      width: "28",
                                      height: "29",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                    },
                                  },
                                  [
                                    _c("defs", [
                                      _c("path", {
                                        attrs: {
                                          id: "a",
                                          d: "M0 .557h27.444V28H0z",
                                        },
                                      }),
                                    ]),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          fill: "none",
                                          "fill-rule": "evenodd",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              transform: "translate(0 .318)",
                                            },
                                          },
                                          [
                                            _c(
                                              "mask",
                                              {
                                                attrs: {
                                                  id: "b",
                                                  fill: "#fff",
                                                },
                                              },
                                              [
                                                _c("use", {
                                                  attrs: { "xlink:href": "#a" },
                                                }),
                                              ]
                                            ),
                                            _c("path", {
                                              attrs: {
                                                d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                                fill: "#000",
                                                mask: "url(#b)",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("path", {
                                          attrs: {
                                            d: "M12.35 21.458c-.327 0-.644-.117-.895-.332l-4.803-4.127a1.372 1.372 0 0 1 1.789-2.082l3.627 3.117 6-9.001a1.372 1.372 0 1 1 2.284 1.522l-6.861 10.29a1.366 1.366 0 0 1-1.141.613",
                                            fill: "#000",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              { staticClass: "flex flex-1 justify-end" },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "tab-status-incomplete",
                                    attrs: {
                                      width: "28",
                                      height: "29",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                    },
                                  },
                                  [
                                    _c("defs", [
                                      _c("path", {
                                        attrs: {
                                          id: "a",
                                          d: "M0 .557h27.444V28H0z",
                                        },
                                      }),
                                    ]),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform: "translate(0 .318)",
                                          fill: "none",
                                          "fill-rule": "evenodd",
                                        },
                                      },
                                      [
                                        _c(
                                          "mask",
                                          { attrs: { id: "b", fill: "#fff" } },
                                          [
                                            _c("use", {
                                              attrs: { "xlink:href": "#a" },
                                            }),
                                          ]
                                        ),
                                        _c("path", {
                                          attrs: {
                                            d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                            fill: "#9B9B9B",
                                            mask: "url(#b)",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-grey-darkest",
                    attrs: { to: `/resources/${_vm.resourceId}/submit` },
                  },
                  [
                    _vm.resource.status === "draft"
                      ? [
                          _vm._v("\n            Submit for Review "),
                          _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "right active-white",
                                  attrs: {
                                    width: "17",
                                    height: "16",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z",
                                      fill: "#010B19",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : [
                          _vm._v("\n            Status "),
                          _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end pr-1" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "float-right mt-1 active-white",
                                  attrs: {
                                    width: "17",
                                    height: "16",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z",
                                      fill: "#010B19",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.user.isAdmin
              ? _c(
                  "li",
                  [
                    _c("admin-queueton-status", {
                      attrs: {
                        resource: "resource",
                        "resource-id": _vm.resourceId,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full md:w-3/4 md:pl-6" },
      [_c("router-view")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }